import { Parcel } from "types/parcel.types"
import { WalletEntryType, WalletFeesType } from "types/wallet-entry.types"
import { WalletPaymentStatus } from "types/wallet-payment.types"

// PACMAN TYPES

export interface WalletPacman {
  bankAccountId: string
  id: string
  keeperId: string
  bankAccount: BankAccount
  balance: number
  balanceDetails: WalletEntriesDetail[]
}

export interface WalletEntriesPacman {
  amount: number
  createdAt: string
  id: string
  parcels: Parcel[]
  paymentId: string | null
  status: WalletPaymentStatus
  type: WalletEntryType | WalletFeesType
  walletId: string
}

export interface WalletPaymentsPacman {
  amount: number
  createdAt: string
  id: string
  status: WalletPaymentStatus
  walletId: string
}

// MOBILE TYPES

export type BankAccount = {
  entitled: string
  bic: string
  iban: string
  id: string
  isStripeValidated: boolean
}

export type Wallet = {
  id: string
  balance: number
  bankAccount?: BankAccount
}

export interface GetMyWallet {
  balance: number
  balanceDetails: WalletEntriesDetail[]
  id: string
  payments: WalletEntries[]
}

export interface WalletEntries {
  amount: number
  createdAt: string
  details: WalletEntriesDetail[]
  status: WalletPaymentStatus
  id: string
}

export interface WalletEntriesDetail {
  nbParcels: number
  processing: boolean
  amount: number
  type: WalletEntryType | WalletFeesType | null
  date: string
  entity: WalletDetailEntity
  associationName: string | null
  parcels: Parcel[]
}

export enum WalletDetailEntity {
  WALLET_ENTRY = "WALLET_ENTRY",
  WALLET_PAYMENT = "WALLET_PAYMENT",
  WALLET_DONATION = "WALLET_DONATION",
  WALLET_FEES = "WALLET_FEES",
  WALLET_GIVEAWAY = "WALLET_GIVEAWAY",
}

export enum TipLinkChannel {
  KEEPER_APP_MANUAL = "keeper_app_manual", // coded on Keeper App (page “OrderDetail” when parcel is DELIVERED_TO_RECIPIENT)
  DIRECT_CTA_EMAIL = "direct_cta_email", // coded on Mailjet
  QR_MOBILE = "qr_mobile", // coded on Keeper app
  QR_PDF = "qr_pdf", // coded on the server when the QR-code is generated for the 1st time
  OPEN_LINK = "open_link", // coded on Keeper App (page “Tip”)
  RATING_SURVEY = "rating_survey", // coded on Pickme web rating survey
  UNKNOWN = "unknown", // validation value
  UNACCEPTABLE = "unacceptable", // validation value
}